import { Fragment } from "react";

/**
 * Render a string with inline tokens:
 *   {gold:text}    → animated gold gradient (pg-text-gold)
 *   {gold-static:text} → static gold (pg-text-gold-static)
 *   {italic:text}  → italic with underline accent
 *   {accent:text}  → accent color text
 * Everything else renders as plain text.
 */
const TOKEN_RE = /\{(gold|gold-static|italic|accent):([^}]+)\}/g;

export const RichText = ({ value, className = "", style }) => {
    if (!value) return null;
    const out = [];
    let last = 0;
    let m;
    let i = 0;
    while ((m = TOKEN_RE.exec(value)) !== null) {
        if (m.index > last) {
            out.push(<Fragment key={`t-${i++}`}>{value.slice(last, m.index)}</Fragment>);
        }
        const kind = m[1];
        const text = m[2];
        if (kind === "gold") {
            out.push(<span key={`g-${i++}`} className="pg-text-gold">{text}</span>);
        } else if (kind === "gold-static") {
            out.push(<span key={`gs-${i++}`} className="pg-text-gold-static">{text}</span>);
        } else if (kind === "italic") {
            out.push(
                <span
                    key={`it-${i++}`}
                    className="italic"
                    style={{
                        textDecoration: "underline",
                        textDecorationColor: "var(--pg-accent)",
                        textDecorationThickness: "2px",
                        textUnderlineOffset: "10px",
                    }}
                >{text}</span>
            );
        } else if (kind === "accent") {
            out.push(<span key={`a-${i++}`} style={{ color: "var(--pg-accent)" }}>{text}</span>);
        }
        last = m.index + m[0].length;
    }
    if (last < value.length) {
        out.push(<Fragment key={`t-${i++}`}>{value.slice(last)}</Fragment>);
    }
    return <span className={className} style={style}>{out}</span>;
};

export default RichText;
